import React from 'react';
export function Footer() {
  return <footer className="bg-black text-zinc-400 py-12 border-t border-amber-900/40" data-id="element-125">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-126">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-127">
          🤝 MASTERPACK APUESTAS MUNDIAL™
        </h4>

        <p className="mb-6 text-sm leading-relaxed" data-id="element-128">
          El sistema educativo N°1 de análisis y estrategia de apuestas
          deportivas para el apostador argentino. Diseñado para quien quiere
          entender el mercado, apostar con criterio real y gestionar su capital
          como un profesional.
          <br data-id="element-129" />
          <strong className="text-zinc-300 mt-2 block" data-id="element-130">
            Porque disfrutar el Mundial apostando no debería depender de si "se
            da el feeling" o de si el tipster de turno publicó su pick a tiempo.
          </strong>
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-131">
          <a href="mailto:masterpackmundial@gmail.com" className="hover:text-amber-400 transition-colors" data-id="element-132">
            📧 masterpackmundial@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-133">·</span>
          <span className="hover:text-amber-400 transition-colors" data-id="element-134">
            📱 @masterpackmundial
          </span>
          <span className="hidden sm:inline" data-id="element-135">·</span>
          <span className="hover:text-amber-400 transition-colors" data-id="element-136">
            🌐 www.masterpackmundial.shop
          </span>
        </div>

        <div className="text-xs text-zinc-600 border-t border-zinc-800 pt-8 space-y-3" data-id="element-137">
          <p data-id="element-138">
            © MASTERPACK APUESTAS MUNDIAL™ 2026 — Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p className="text-zinc-500" data-id="element-139">
            ⚠️ Aviso legal: Este es un producto educativo. Las apuestas
            deportivas implican riesgo de pérdida de capital. El conocimiento
            mejora la toma de decisiones pero no garantiza resultados
            financieros. Apostá responsablemente.
          </p>
          <p className="italic text-amber-300/80" data-id="element-140">
            🏆🇦🇷 "La próxima jornada, vas a saber exactamente qué apostar y por
            qué."
          </p>
        </div>
      </div>
    </footer>;
}